import { Button, Input, Modal } from "antd";
import { Content } from "antd/es/layout/layout";
import { ChangeEvent, FC, useState } from "react";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../interfaces/users";
import { api } from "../../config";
import { toast } from "react-toastify";

interface ImportClientByDocumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectClient?: () => void;
}

export const ImportClientByDocumentModal: FC<
  ImportClientByDocumentModalProps
> = ({ isOpen, onClose, onSelectClient }) => {
      const { token } = useSelector((state: AuthenticationState) => state);
      const [loading, setLoading] = useState(false);
    
  const [document, setDocument] = useState("");

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = e;
    setDocument(value.replace(/\D+/gi, ""));
  };

  const handleClose = () => {
    setDocument("");
    onClose();
  };

  const handleImportClient = async () => {
    setLoading(true)
    try {
        await api(token).post('/clients/import', {document})
        toast.success("Cliente importado com sucesso!")
        handleClose()
    } catch (error: any) {
        console.log(error?.response?.data?.error)
        toast.error(error?.response?.data?.error ?? "Ocorreu um erro ao importar o cliente.")
    } finally {
        setLoading(false)
    }
  } 

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      onCancel={handleClose}
      footer={() => (
        <div className="w-full flex justify-between">
          <Button onClick={handleClose} loading={loading} variant="solid" color="red">
            Cancelar
          </Button>
          <Button onClick={handleImportClient} loading={loading} variant="solid" color="primary">
            Importar
          </Button>
        </div>
      )}
    >
      <h2>Importar Cliente:</h2>
      <Content>
        <p>
          CPF/CNPJ <span className="text-red-600">*</span>{" "}
          <b>(Somente números)</b>:
        </p>
        <Input value={document} onChange={handleChange} />
      </Content>
    </Modal>
  );
};
